import React, { useContext } from "react";
import { ProductDetailsContext } from "../ProductDetailsView";
import Loader from "../../../../components/Loader/Loader";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import BorderButton from "../../../../components/BorderButton/BorderButton";
import SuccessPopupAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import DeleteAlertBox from "../../../../components/AlertComponent/AlertBox";
import ContentData from "../../../../constants/contentFile.json";
import EditIcon from "../../../../assets/images/editIcon.png";
import DeleteIcon from "../../../../assets/images/deleteIcon.png";
import DeletePopupImage from "../../../../assets/images/delete.svg";
import NextIcon from "../../../../assets/images/next-icon.svg";
import "./productDetails.css";
import inverterImage from "../../../../assets/images/inverterDummy.png";
import SelectItem from "../../../../components/ThemeSelectOption/SelectOption";
import AlertBox from "../../../../components/AlertComponent/AlertBox";
import PopupAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import ToggleArrow from "../../../../assets/images/Toggle-arrow.svg";

const ProductDetails = () => {
  const {
    permissionAccess,
    goToProductList,
    spinnerStatus,
    statuses,
    editProduct,
    deleteProduct,
    deleteAlert,
    setDeleteAlert,
    productType,
    successPopup,
    setSuccessPopup,
    successPopupMessage,
    productTableList,
    getProductDetails,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
    productToLogin,
    buttonText,
    statusValue,
    productDetails,
    selectedStatus,
    handleStatusChange,
  } = useContext(ProductDetailsContext);

  return (
    <div className="pageBg productDetails">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={goToProductList}>
          {ContentData.productPage.pageTitle}
        </span>
        <img className="nextIcon " src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.productPage.productDetail}
        </span>
      </div>
      <Container>
        {spinnerStatus && <Loader />}
        <div className="flexPage">
          <div className="headFlexing">
            <button type="button" onClick={goToProductList} class="navbar-btn">
              <img src={ToggleArrow} alt="toggle-arrow" />
            </button>
            <div className="pageTittles">
              {ContentData.productPage.productDetail}
            </div>
            <div className="subFlexing">
              <div
                className={`status-selector ${
                  permissionAccess?.delete ? "" : "disabledIconOnly"
                }`}
              >
                <SelectItem
                  selectPlaceholder="Status"
                  values={statuses}
                  selectNum="_id"
                  label="name"
                  defaultValue={selectedStatus}
                  handleSelectData={handleStatusChange}
                />
              </div>
              {/* edit */}
              <div
                className={`deletEditSection ${
                  permissionAccess?.edit ? "" : "disabledIconOnly"
                }`}
                onClick={editProduct}
              >
                <img src={EditIcon} alt="edit" />
              </div>
              <div
                className={`deletEditSection ${
                  permissionAccess?.delete ? "" : "disabledIconOnly"
                }`}
                onClick={() => setDeleteAlert(true)}
              >
                <img src={DeleteIcon} alt="delete" />
              </div>
            </div>
          </div>
        </div>
        <div className="basicContainer">
          <Row>
            <Col xl="12" lg="12" sm="12">
              <div className="product-type">
                <div className="adminDetailSectionTop roleSubPage">
                  <div className="product-type-name">{productType}</div>
                </div>
              </div>
            </Col>
          </Row>
          <div className="viewDetailSection">
            {/* model */}
            <Row>
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.productPage?.Model}</h4>
                    <h5>
                      {productDetails?.modelName
                        ? productDetails?.modelName
                        : "-"}
                    </h5>
                  </div>
                </div>
              </Col>
              {productType === "inverter" && (
                <>
                  {/* power */}
                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData?.productPage?.Power}</h4>
                        <h5>
                          {productDetails?.power
                            ? ` ${productDetails?.power} W`
                            : "-"}
                        </h5>
                      </div>
                    </div>
                  </Col>
                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData?.productPage?.PowerVA}</h4>
                        <h5>
                          {productDetails?.powerInVoltAmperes
                            ? ` ${productDetails?.powerInVoltAmperes} VA`
                            : "-"}
                        </h5>
                      </div>
                    </div>
                  </Col>

                  {/* battery volt */}
                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData?.productPage?.BattVolt}</h4>
                        <h5>
                          {productDetails?.batteryVoltage
                            ? ` ${productDetails?.batteryVoltage} V`
                            : "-"}
                        </h5>
                      </div>
                    </div>
                  </Col>

                  {/* type */}

                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData?.productPage?.Type}</h4>
                        <h5>
                          {productDetails?.type ? productDetails?.type : "-"}
                        </h5>
                      </div>
                    </div>
                  </Col>
                  {/* connectivity */}
                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData?.productPage?.Connectivity}</h4>
                        <h5>{productDetails?.connectivity ? "Yes" : "No"}</h5>
                      </div>
                    </div>
                  </Col>
                  {/* productLink */}
                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData?.productPage?.ProductLink}</h4>
                        <h5>
                          {productDetails?.url ? (
                            <a
                              href={productDetails.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View Product
                            </a>
                          ) : (
                            "-"
                          )}
                        </h5>
                      </div>
                    </div>
                  </Col>
                  {/* solarmodel */}
                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData?.productPage?.SolarModel}</h4>
                        <h5>{productDetails?.solarModel ? "Yes" : "No"}</h5>
                      </div>
                    </div>
                  </Col>
                </>
              )}

              {/* capcity */}
              {productType == "battery" && (
                <Col xl="4" lg="4" sm="12">
                  <div className="adminDetailSection">
                    <div className="adminDetailSectionTop roleSubPage">
                      <h4>{ContentData?.productPage?.Capacity}</h4>
                      <h5>
                        {productDetails?.capacity
                          ? ` ${productDetails?.capacity} Ah`
                          : "-"}
                      </h5>
                    </div>
                  </div>
                </Col>
              )}

              {/* site origin */}
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.productPage?.SiteOrigin}</h4>
                    <h5>
                      {productDetails?.siteOrigin === "in"
                        ? "vguard.in"
                        : "vguard.com"}
                    </h5>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.productPage?.ProductImage}</h4>
                    <div className="product-image">
                      <img
                        src={productDetails?.image ? productDetails?.image : ""}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>

      {/* delete product */}
      <AlertBox
        alertMessage={ContentData.productPage.deleteSure}
        buttonSubmitText={ContentData.productPage.deleteText}
        popImage={DeletePopupImage}
        show={deleteAlert}
        setShow={setDeleteAlert}
        handleSubmitData={() => deleteProduct()}
        handleCancelClick={() => setDeleteAlert(false)}
      />
      <PopupAlertError
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            productToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            getProductDetails(productType);
          }
        }}
        errorAlertOnly={statusValue === 400 ? true : false}
      />
      {/* success popup */}
      <PopupAlert
        show={successPopup}
        alertMessage={successPopupMessage}
        handleSubmit={() => {
          setSuccessPopup(false);
          productTableList();
        }}
      />
    </div>
  );
};

export default ProductDetails;
